/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Help_TextInputs */

const de_auth_mfa_help_text = /** @type {(inputs: Auth_Mfa_Help_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie benötigen Hilfe?`)
};

/** @type {(inputs: Auth_Mfa_Help_TextInputs) => LocalizedString} */
const en_auth_mfa_help_text = de_auth_mfa_help_text;

/**

* @param {Auth_Mfa_Help_TextInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_help_text = /** @type {((inputs?: Auth_Mfa_Help_TextInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Help_TextInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_help_text(inputs)
	return en_auth_mfa_help_text(inputs)
});